// Client for the per-site analytics endpoint. Shapes mirror
// packages/server/src/routes/analytics.ts.

import { apiFetch } from './api';

export interface SiteAnalytics {
  range: { from: string; to: string };
  visitors: {
    new: number;
    returning: number;
    identified: number;
    seen: number;
    conversionPct: number;
    daily: Array<{ date: string; new: number; engaged: number }>;
  };
  chats: {
    total: number;
    byMedium: { chat: number; video: number };
    byOwner: { ai: number; agent: number };
    startedBy: { visitor: number; agent: number; ai: number };
    aiDeflectionPct: number;
    daily: Array<{ date: string; agent: number; ai: number; none: number }>;
  };
  resolution: {
    endReasons: Array<{ reason: string; count: number }>;
    avgDurationSec: number;
    avgMessages: number;
    avgFirstResponseSec: number;
  };
  agents: Array<{
    agentId: string;
    name: string;
    chatsHandled: number;
    avgDurationSec: number;
    activeSec: number;
  }>;
  webhooks: {
    total: number;
    byEvent: Record<string, number>;
    byStatus: { success: number; failed: number; skipped: number };
    byKind: { http: number; email: number };
  };
  topPages: Array<{ url: string; count: number }>;
  geo: Array<{ country: string; count: number }>;
  busiestHours: Array<{ hour: number; agent: number; ai: number; none: number }>;
}

export async function getSiteAnalytics(
  siteId: string,
  fromISO: string,
  toISO: string,
): Promise<SiteAnalytics> {
  const qs = new URLSearchParams({ from: fromISO, to: toISO }).toString();
  const { analytics } = await apiFetch<{ analytics: SiteAnalytics }>(
    `/api/admin/sites/${siteId}/analytics?${qs}`,
  );
  return analytics;
}
